import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.invoice.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'invoices',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async read({ commit }, id) {
    const { data } = await this.$axios.get(routes.invoice.concrete(id))

    return data
  },
  async payByBank({ commit }, id) {
    const { data } = await this.$axios.post(
      routes.invoice.payByBank(id),
      {},
      {
        responseType: 'blob'
      }
    )

    return data
  },
  async payByCard({ commit }, id) {
    const { data } = await this.$axios.post(
      routes.invoice.payByCard(id),
      {},
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )

    return data
  },
  async payByBalance({ commit }, id) {
    const { data } = await this.$axios.post(
      routes.invoice.payByBalance(id),
      {},
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )

    return data
  }
}
